export const TipoRegistroSelect = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='P'>PowerGard</option>
            <option value='M'>Poliza de Mantenimiento</option>
        </select>
    )
}